module.exports = __webpack_public_path__ + "static/media/search.d518c4bb.svg";